import PlantAndStaff from "../../../container/staff_and_plant/index";
import StaffAndPlantWrapper from "../../../components/staffandplant/staffandplantwrapper";
// import WorkHours from "../../../container/staff_and_plant/workhour";

const staff_and_plantRoute = [
  {
    path: "staff_and_plant",
    element: <PlantAndStaff />,
  },
  {
    path: "staff_and_plant/staffList",
    element: <StaffAndPlantWrapper activeComponent="staff" />,
  },
  {
    path: "staff_and_plant/plantList", 
    element: <StaffAndPlantWrapper activeComponent="plant" />,
  },
  // {
  //   path: "staff_and_plant/workHour",
  //   element: <WorkHours />,
  // },
];

export default staff_and_plantRoute;
